import { useCallback } from 'react'
import { useFormikContext } from 'formik'

export function useHandlers() {
  const { setFieldValue } = useFormikContext()

  const onChange = useCallback(
    (_e, value: { value: string; label: string }[]) =>
      setFieldValue(
        'targetPests',
        value.map((x) => x.value),
      ),
    [setFieldValue],
  )

  return { onChange }
}
